
import { getJSON } from './helper.js';

export const state = {
    recipe: {},
    search: {
      query: '',
      results: [],
      sum:[]
       
    }
  };

  

export const loadSearchResults = async function (query) {
    try {
      state.search.query = query;
      const data = await getJSON(`https://cloud.bgate-erp.com/BgateAdmin228/RepQueryWebService.asp?WebService=y&UserName=Inokimws&UserPassword=Inokim18&resultformattype=json&RemoveUTF8ByteOrderMark=y&RepQueryName=GetUserDevices&ID=${query}&ImportMsgIsUnicode=y`);
      const test = (data['ResultRecord'])
      console.log(test.length)
      let quick4 = []
      let ox = []
      let quick3 = []
      let ligh2  = []
      test.forEach(el =>{
        if(el.SKU === '190950235' || el.SKU === '190950300'){
           quick4.push(el)
        }
        if(el.SKU === '190950251' || el.SKU === '80000' || el.SKU === '190950250'){
           ox.push(el)
        }
        if(el.SKU=== '50001' || el.SKU === '50002' || el.SKU === '50003'|| el.SKU === '50004' || el.SKU === '50005'){
           quick3.push(el)
        }
        if(el.SKU === '20001M' || el.SKU === '20002M' || el.SKU === '20003M' || el.SKU === '20004M' || el.SKU === '20005M' || el.SKU === '20005'){
          ligh2.push(el)
        }
      })

      state.search.sum = {
        ox: ox.length,
        quick4: quick4.length,
        ligh2: ligh2.length,
        quick3: quick3.length
      }
     
    
     

    //   console.log(`quick4- ${state.search.sum.quick4.length}`)
    //   console.log(`quick3- ${state.search.sum.quick3.length}`)
    //   console.log(`ox- ${state.search.sum.ox.length}`) 
    //   console.log(`light- ${state.search.sum.ligh2.length}`)
      
    //   state.search.results = data['ResultRecord'].map(rec => {
    //     return {
    //       id: rec.ID,
    //       category: rec.Category,
    //       description: rec.Description,
    //       Serial: rec.Serial,
    //       date: rec.Date
    //     };
    //   });
    } catch (err) {
      console.error(`${err} :(`);
      throw err;
    }
  };